import $ from 'jquery';

$('.show-more').hide();

if ($('.categories-list__list').length > 7) {
    $('.categories-list__list:gt(7)').hide();
    $('.show-more').show();
}
$('.show-more span').on('click', function() {
    //toggle elements with class .ty-compact-list that their index is bigger than 2
    $('.categories-list__list:gt(7)').toggle();
    //change text of show more element just for demonstration purposes to this demo
    $(this).text() === 'Voir plus' ? $(this).text('Voir moins') : $(this).text('Voir plus');
});
